import { AxiosError } from 'axios';
import { alertService } from 'shared/ui/components/alert/service';

export const handleErrorWithAlert = (error: unknown, text?: string) => {
  if (error instanceof AxiosError) {
    alertService.show(error.response?.data?.detail || text || error.message);
  }
  console.log(error);
};
